var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 481 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.76 75.9719C457.545 75.9719 466.288 84.7497 466.288 95.5776C466.288 106.405 457.545 115.183 446.76 115.183H335.173C345.958 115.183 354.701 123.961 354.701 134.789C354.701 145.617 345.958 154.394 335.173 154.394H396.546C407.331 154.394 416.074 163.172 416.074 174C416.074 184.828 407.331 193.606 396.546 193.606H368.164C354.566 193.606 343.542 202.383 343.542 213.211C343.542 220.43 349.121 226.965 360.28 232.817C371.065 232.817 379.808 241.595 379.808 252.423C379.808 263.251 371.065 272.028 360.28 272.028H128.737C117.952 272.028 109.209 263.251 109.209 252.423C109.209 241.595 117.952 232.817 128.737 232.817H19.9398C9.15497 232.817 0.412109 224.039 0.412109 213.211C0.412109 202.383 9.15497 193.606 19.9398 193.606H131.527C142.312 193.606 151.055 184.828 151.055 174C151.055 163.172 142.312 154.394 131.527 154.394H61.785C51.0001 154.394 42.2572 145.617 42.2572 134.789C42.2572 123.961 51.0001 115.183 61.785 115.183H173.372C162.587 115.183 153.844 106.405 153.844 95.5776C153.844 84.7497 162.587 75.9719 173.372 75.9719H446.76ZM446.76 154.394C457.545 154.394 466.288 163.172 466.288 174C466.288 184.828 457.545 193.606 446.76 193.606C435.975 193.606 427.232 184.828 427.232 174C427.232 163.172 435.975 154.394 446.76 154.394Z",
    fill: "#F3F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.187 231.42C288.306 231.42 314.343 205.323 314.343 173.13C314.343 140.937 288.306 114.84 256.187 114.84C224.069 114.84 198.031 140.937 198.031 173.13C198.031 205.323 224.069 231.42 256.187 231.42Z",
    fill: "#F3F7FF",
    stroke: "#01579B",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.869 218.359C249.922 218.924 253.028 219.218 256.188 219.24C281.595 219.24 302.192 198.596 302.192 173.13C302.192 147.664 281.595 127.02 256.188 127.02C249.661 127.02 243.452 128.382 237.827 130.839C228.054 135.107 220.047 142.68 215.211 152.149C211.997 158.443 210.184 165.574 210.184 173.13C210.184 179.986 211.676 186.492 214.354 192.34C216.265 196.515 218.781 200.355 221.788 203.746",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.869 218.359C249.922 218.924 253.028 219.218 256.188 219.24C281.595 219.24 302.192 198.596 302.192 173.13C302.192 147.664 281.595 127.02 256.188 127.02C249.661 127.02 243.452 128.382 237.827 130.839C228.054 135.107 220.047 142.68 215.211 152.149C211.997 158.443 210.184 165.574 210.184 173.13C210.184 179.986 211.676 186.492 214.354 192.34C216.265 196.515 218.781 200.355 221.788 203.746",
    stroke: "#01579B",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.191 208.93C230.921 211.968 235.134 214.433 239.697 216.189",
    stroke: "#1F64E7",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M303.928 219.24L314.344 229.68",
    stroke: "#01579B",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.66 227.993C309.374 231.286 309.374 236.626 312.66 239.919L331.904 259.207C335.189 262.501 340.517 262.501 343.802 259.207C347.088 255.914 347.088 250.574 343.802 247.281L324.558 227.993C321.273 224.699 315.945 224.699 312.66 227.993Z",
    fill: "#E8F0FE",
    stroke: "#01579B",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M321.287 231.42L340.383 250.56",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.903 153.12C244.903 173.301 261.224 189.66 281.359 189.66C285.314 189.66 289.122 189.029 292.688 187.861C286.867 202.34 272.718 212.56 256.187 212.56C234.46 212.56 216.848 194.907 216.848 173.13C216.848 153.398 231.309 137.051 250.189 134.156C246.835 139.686 244.903 146.177 244.903 153.12Z",
    fill: "#E8F0FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M257.054 140.94C254.844 140.94 252.684 141.158 250.595 141.574M244.286 143.509C232.41 148.511 224.07 160.279 224.07 174",
    stroke: "#1E88E5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M349.37 173.613H335.176M360.348 160.08H330.531H360.348ZM372.5 160.08H368.644H372.5Z",
    stroke: "#1E88E5",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.129 211.893H178.936M185.012 196.62H155.195H185.012ZM145.084 196.62H137.756H145.084Z",
    stroke: "#1E88E5",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearchIcon);
export default __webpack_public_path__ + "static/media/emptySearchIcon.7bc76586.svg";
export { ForwardRef as ReactComponent };